import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

const TrackingHistory = ({ data, heading }) => {
  const { t } = useTranslation("carrier");
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <div className="bg-ui-surface max-h-[250px] mt-2 overflow-y-auto">
        <h2 className="text-sm font-semibold text-ui-text mb-3">{heading ?? t("dispatcher.trackingHistory")}</h2>
        <div className="pl-2">
          <div className="relative pl-6 border-l-2 border-ui-border">
            <div className="absolute -left-2 bottom-0 w-4 h-8 bg-ui-surface"></div>
            {Array.isArray(data) &&
              data?.map((entry, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                  className="relative mb-2"
                >
                  {/* Timeline Dot */}
                  <div
                    className="absolute -left-[32.2px] -top-1 w-4 h-4 border-4 border-white rounded-full"
                    style={{
                      backgroundColor:
                        entry.ShipmentStatus === "Returned"
                          ? "var(--color-danger-text)"
                          : index === data?.length - 1
                          ? "#10B981"
                          : entry.ShipmentStatus === "Creation"
                          ? "lightgray"
                          : "#3B82F6",
                    }}
                  ></div>

                  {/* Status Info */}
                  <div className="bg-ui-surface-sunken p-1.5 rounded-md shadow-glass">
                    <div className="text-[8px] text-ui-text-muted">
                      {entry.StatusDate}
                    </div>
                    <div className="text-xs font-semibold text-ui-text mb-[2px]">
                      {entry.ShipmentStatus}
                    </div>

                    {entry.note && (
                      <div className="text-[10px] text-ui-text-muted">{entry.note}</div>
                    )}

                    {entry.status_media?.length ? (
                      <div className="w-full flex flex-wrap gap-1 mt-1">
                        {entry.status_media?.map((image, i) => (
                          <img
                            key={i}
                            src={image?.file}
                            alt={t("dispatcher.status")}
                            className="w-5 h-5 object-contain rounded-sm border border-ui-border cursor-pointer"
                            onClick={() => setSelectedImage(image?.file)}
                          />
                        ))}
                      </div>
                    ) : null}
                  </div>
                </motion.div>
              ))}
          </div>
        </div>
      </div>

      {/* Fullscreen Image Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="fixed inset-0 backdrop-blur-sm bg-black/60 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className="relative"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              onClick={(e) => e.stopPropagation()} // prevent modal close on image click
            >
              {/* Close Button on Image Corner */}
              <button
                className="absolute top-1 right-1 bg-ui-surface text-ui-text rounded-full w-6 h-6 text-xl flex items-center justify-center shadow"
                onClick={() => setSelectedImage(null)}
              >
                &times;
              </button>

              <img
                src={selectedImage}
                alt={t("dispatcher.fullView")}
                className="w-[500px] max-w-[90vw] max-h-[90vh] rounded-lg shadow-xl object-contain"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default TrackingHistory;
